var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoyan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 26.5C19.8284 26.5 20.5 27.1716 20.5 28V52C20.5 52.8284 19.8284 53.5 19 53.5C18.1716 53.5 17.5 52.8284 17.5 52V28C17.5 27.1716 18.1716 26.5 19 26.5Z",
    fill: "#BC90E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 26.5C33.8284 26.5 34.5 27.1716 34.5 28V52C34.5 52.8284 33.8284 53.5 33 53.5C32.1716 53.5 31.5 52.8284 31.5 52V28C31.5 27.1716 32.1716 26.5 33 26.5Z",
    fill: "#BC90E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 32.5C12.8284 32.5 13.5 33.1716 13.5 34V46C13.5 46.8284 12.8284 47.5 12 47.5C11.1716 47.5 10.5 46.8284 10.5 46V34C10.5 33.1716 11.1716 32.5 12 32.5Z",
    fill: "#C8A7E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 32.5C26.8284 32.5 27.5 33.1716 27.5 34V46C27.5 46.8284 26.8284 47.5 26 47.5C25.1716 47.5 24.5 46.8284 24.5 46V34C24.5 33.1716 25.1716 32.5 26 32.5Z",
    fill: "#C8A7E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 32.5C40.8284 32.5 41.5 33.1716 41.5 34V46C41.5 46.8284 40.8284 47.5 40 47.5C39.1716 47.5 38.5 46.8284 38.5 46V34C38.5 33.1716 39.1716 32.5 40 32.5Z",
    fill: "#C8A7E6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88 77.4705C88 76.1061 79.0457 75 68 75C56.9543 75 48 76.1061 48 77.4705V81.5295C48 82.8939 56.9543 84 68 84C79.0457 84 88 82.8939 88 81.5295V77.4705Z",
    fill: "#474343"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.6273 75.2604C88.9687 75.4665 90 76.1506 90 77.4705V81.5295C90 82.8494 88.9687 83.5335 88.6273 83.7396C88.1421 84.0324 87.5566 84.2451 86.989 84.4109C85.8236 84.7513 84.235 85.0331 82.3873 85.2613C78.664 85.7212 73.5782 86 68 86C62.4218 86 57.336 85.7212 53.6127 85.2613C51.765 85.0331 50.1764 84.7513 49.011 84.4109C48.4434 84.2451 47.8579 84.0324 47.3727 83.7396C47.0313 83.5335 46 82.8494 46 81.5295V77.4705C46 76.1506 47.0313 75.4665 47.3727 75.2604C47.8579 74.9676 48.4434 74.7549 49.011 74.5891C50.1764 74.2487 51.765 73.9669 53.6127 73.7387C57.336 73.2788 62.4218 73 68 73C73.5782 73 78.664 73.2788 82.3873 73.7387C84.235 73.9669 85.8236 74.2487 86.989 74.5891C87.5566 74.7549 88.1421 74.9676 88.6273 75.2604ZM68 75C79.0457 75 88 76.1061 88 77.4705V81.5295C88 82.8939 79.0457 84 68 84C56.9543 84 48 82.8939 48 81.5295V77.4705C48 76.1061 56.9543 75 68 75Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M88 81.5295V78.4705C86.5017 79.6869 81.8303 80.4067 77 80.7565V83.7363C83.5252 83.3295 88 82.494 88 81.5295Z",
    fill: "#2A2828"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88 77.5C88 78.8807 79.0457 80 68 80C56.9543 80 48 78.8807 48 77.5C48 76.1193 56.9543 75 68 75C79.0457 75 88 76.1193 88 77.5Z",
    fill: "#525252"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.3391 78.499C86.2854 78.5144 86.2305 78.5298 86.1743 78.545C83.0086 79.4038 76.0613 80 68 80C59.9387 80 52.9914 79.4038 49.8257 78.545C49.7695 78.5298 49.7146 78.5144 49.6609 78.4991C48.5926 78.1931 48 77.8552 48 77.5C48 77.1448 48.5926 76.8069 49.6609 76.501C49.7146 76.4856 49.7695 76.4702 49.8257 76.455C52.9914 75.5962 59.9387 75 68 75C76.0613 75 83.0086 75.5962 86.1743 76.455C86.2305 76.4702 86.2854 76.4856 86.3391 76.501C87.4074 76.8069 88 77.1448 88 77.5C88 77.8552 87.4074 78.1931 86.3391 78.499ZM86.5511 76.2971C86.5484 76.2987 86.5452 76.3006 86.5416 76.3026C86.5854 76.2698 86.5974 76.2688 86.5511 76.2971ZM49.4489 76.2971C49.4026 76.2688 49.4146 76.2698 49.4584 76.3027C49.4548 76.3006 49.4516 76.2987 49.4489 76.2971ZM49.4489 78.7029C49.4516 78.7013 49.4548 78.6994 49.4584 78.6973C49.4146 78.7302 49.4026 78.7312 49.4489 78.7029ZM86.5511 78.7029C86.5974 78.7312 86.5854 78.7302 86.5416 78.6974C86.5452 78.6994 86.5484 78.7013 86.5511 78.7029ZM82.3902 81.2523C78.6657 81.7179 73.5789 82 68 82C62.4211 82 57.3343 81.7179 53.6098 81.2523C51.7616 81.0213 50.1717 80.7359 49.0049 80.3911C48.4364 80.2231 47.8497 80.0074 47.3637 79.7106C47.0147 79.4974 46 78.8104 46 77.5C46 76.1896 47.0147 75.5026 47.3637 75.2894C47.8497 74.9926 48.4364 74.7769 49.0049 74.6089C50.1717 74.2641 51.7616 73.9787 53.6098 73.7477C57.3343 73.2821 62.4211 73 68 73C73.5789 73 78.6657 73.2821 82.3902 73.7477C84.2384 73.9787 85.8283 74.2641 86.9951 74.6089C87.5636 74.7769 88.1503 74.9926 88.6363 75.2894C88.9853 75.5026 90 76.1896 90 77.5C90 78.8104 88.9853 79.4974 88.6363 79.7106C88.1503 80.0074 87.5636 80.2231 86.9951 80.3911C85.8283 80.7359 84.2384 81.0213 82.3902 81.2523Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5097 81.9019C51.5638 81.6312 51.8273 81.4556 52.098 81.5097C53.3124 81.7526 55.9055 82.0009 58.4124 82.1889C60.914 82.3765 63.2713 82.5 64 82.5C64.2761 82.5 64.5 82.7239 64.5 83C64.5 83.2761 64.2761 83.5 64 83.5C63.2287 83.5 60.8359 83.3735 58.3376 83.1861C55.8444 82.9991 53.1875 82.7474 51.9019 82.4903C51.6311 82.4361 51.4555 82.1727 51.5097 81.9019Z",
    fill: "#6A6565"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51 27C51.5523 27 52 27.4477 52 28V58C52 61.866 55.134 65 59 65H77C80.866 65 84 61.866 84 58V28C84 27.4477 84.4477 27 85 27C85.5523 27 86 27.4477 86 28V58C86 62.9706 81.9706 67 77 67H59C54.0294 67 50 62.9706 50 58V28C50 27.4477 50.4477 27 51 27Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M66 63H70L73 77H63L66 63Z",
    fill: "#3E3B3B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.0444 62.5809C64.242 61.6588 65.0569 61 66 61H70C70.9431 61 71.758 61.6588 71.9556 62.5809L74.9556 76.5809C75.0822 77.1715 74.9351 77.7877 74.5554 78.2574C74.1756 78.7271 73.604 79 73 79H63C62.396 79 61.8244 78.7271 61.4447 78.2574C61.065 77.7877 60.9179 77.1715 61.0444 76.5809L64.0444 62.5809ZM66 63H70L73 77H63L66 63Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M66 63H67L66 77H63L66 63Z",
    fill: "#575454"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M69 63H70L73 77H70L69 63Z",
    fill: "#212020"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M55 16C55 13.7909 56.7909 12 59 12H77C79.2091 12 81 13.7909 81 16V54C81 56.2091 79.2091 58 77 58H59C56.7909 58 55 56.2091 55 54V16Z",
    fill: "#525252"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59 10H77C80.3137 10 83 12.6863 83 16V54C83 57.3137 80.3137 60 77 60H59C55.6863 60 53 57.3137 53 54V16C53 12.6863 55.6863 10 59 10ZM59 12C56.7909 12 55 13.7909 55 16V54C55 56.2091 56.7909 58 59 58H77C79.2091 58 81 56.2091 81 54V16C81 13.7909 79.2091 12 77 12H59Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79 15C79.5523 15 80 15.4477 80 16V44H78V16C78 15.4477 78.4477 15 79 15Z",
    fill: "#757575"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57 15C57.5523 15 58 15.4477 58 16V44H56V16C56 15.4477 56.4477 15 57 15Z",
    fill: "#9D9D9D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M55 44H81V54C81 56.2091 79.2091 58 77 58H59C56.7909 58 55 56.2091 55 54V44Z",
    fill: "#312E2E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56 54V44H58V54C58 54.5523 57.5523 55 57 55C56.4477 55 56 54.5523 56 54Z",
    fill: "#535353"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78 54V44H80V54C80 54.5523 79.5523 55 79 55C78.4477 55 78 54.5523 78 54Z",
    fill: "#535353"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M79 15C79 14.4477 78.5523 14 78 14C77.4477 14 77 14.4477 77 15C77 15.5523 77.4477 16 78 16C78.5523 16 79 15.5523 79 15Z",
    fill: "#353535"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M79 19C79 18.4477 78.5523 18 78 18C77.4477 18 77 18.4477 77 19C77 19.5523 77.4477 20 78 20C78.5523 20 79 19.5523 79 19Z",
    fill: "#353535"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M75 19C75 18.4477 74.5523 18 74 18C73.4477 18 73 18.4477 73 19C73 19.5523 73.4477 20 74 20C74.5523 20 75 19.5523 75 19Z",
    fill: "#353535"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M77 17C77 16.4477 76.5523 16 76 16C75.4477 16 75 16.4477 75 17C75 17.5523 75.4477 18 76 18C76.5523 18 77 17.5523 77 17Z",
    fill: "#353535"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M73 17C73 16.4477 72.5523 16 72 16C71.4477 16 71 16.4477 71 17C71 17.5523 71.4477 18 72 18C72.5523 18 73 17.5523 73 17Z",
    fill: "#353535"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M75 15C75 14.4477 74.5523 14 74 14C73.4477 14 73 14.4477 73 15C73 15.5523 73.4477 16 74 16C74.5523 16 75 15.5523 75 15Z",
    fill: "#353535"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M77 21C77 20.4477 76.5523 20 76 20C75.4477 20 75 20.4477 75 21C75 21.5523 75.4477 22 76 22C76.5523 22 77 21.5523 77 21Z",
    fill: "#353535"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M77 25C77 24.4477 76.5523 24 76 24C75.4477 24 75 24.4477 75 25C75 25.5523 75.4477 26 76 26C76.5523 26 77 25.5523 77 25Z",
    fill: "#353535"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M73 25C73 24.4477 72.5523 24 72 24C71.4477 24 71 24.4477 71 25C71 25.5523 71.4477 26 72 26C72.5523 26 73 25.5523 73 25Z",
    fill: "#353535"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M75 23C75 22.4477 74.5523 22 74 22C73.4477 22 73 22.4477 73 23C73 23.5523 73.4477 24 74 24C74.5523 24 75 23.5523 75 23Z",
    fill: "#353535"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M79 23C79 22.4477 78.5523 22 78 22C77.4477 22 77 22.4477 77 23C77 23.5523 77.4477 24 78 24C78.5523 24 79 23.5523 79 23Z",
    fill: "#353535"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M79 27C79 26.4477 78.5523 26 78 26C77.4477 26 77 26.4477 77 27C77 27.5523 77.4477 28 78 28C78.5523 28 79 27.5523 79 27Z",
    fill: "#353535"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M75 27C75 26.4477 74.5523 26 74 26C73.4477 26 73 26.4477 73 27C73 27.5523 73.4477 28 74 28C74.5523 28 75 27.5523 75 27Z",
    fill: "#353535"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M71 23C71 22.4477 70.5523 22 70 22C69.4477 22 69 22.4477 69 23C69 23.5523 69.4477 24 70 24C70.5523 24 71 23.5523 71 23Z",
    fill: "#353535"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M73 21C73 20.4477 72.5523 20 72 20C71.4477 20 71 20.4477 71 21C71 21.5523 71.4477 22 72 22C72.5523 22 73 21.5523 73 21Z",
    fill: "#353535"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M71 15C71 14.4477 70.5523 14 70 14C69.4477 14 69 14.4477 69 15C69 15.5523 69.4477 16 70 16C70.5523 16 71 15.5523 71 15Z",
    fill: "#353535"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M71 19C71 18.4477 70.5523 18 70 18C69.4477 18 69 18.4477 69 19C69 19.5523 69.4477 20 70 20C70.5523 20 71 19.5523 71 19Z",
    fill: "#353535"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M67 19C67 18.4477 66.5523 18 66 18C65.4477 18 65 18.4477 65 19C65 19.5523 65.4477 20 66 20C66.5523 20 67 19.5523 67 19Z",
    fill: "#353535"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M69 17C69 16.4477 68.5523 16 68 16C67.4477 16 67 16.4477 67 17C67 17.5523 67.4477 18 68 18C68.5523 18 69 17.5523 69 17Z",
    fill: "#353535"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M65 17C65 16.4477 64.5523 16 64 16C63.4477 16 63 16.4477 63 17C63 17.5523 63.4477 18 64 18C64.5523 18 65 17.5523 65 17Z",
    fill: "#353535"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M67 15C67 14.4477 66.5523 14 66 14C65.4477 14 65 14.4477 65 15C65 15.5523 65.4477 16 66 16C66.5523 16 67 15.5523 67 15Z",
    fill: "#353535"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M69 21C69 20.4477 68.5523 20 68 20C67.4477 20 67 20.4477 67 21C67 21.5523 67.4477 22 68 22C68.5523 22 69 21.5523 69 21Z",
    fill: "#353535"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M69 25C69 24.4477 68.5523 24 68 24C67.4477 24 67 24.4477 67 25C67 25.5523 67.4477 26 68 26C68.5523 26 69 25.5523 69 25Z",
    fill: "#353535"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M65 25C65 24.4477 64.5523 24 64 24C63.4477 24 63 24.4477 63 25C63 25.5523 63.4477 26 64 26C64.5523 26 65 25.5523 65 25Z",
    fill: "#353535"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M67 23C67 22.4477 66.5523 22 66 22C65.4477 22 65 22.4477 65 23C65 23.5523 65.4477 24 66 24C66.5523 24 67 23.5523 67 23Z",
    fill: "#353535"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M63 15C63 14.4477 62.5523 14 62 14C61.4477 14 61 14.4477 61 15C61 15.5523 61.4477 16 62 16C62.5523 16 63 15.5523 63 15Z",
    fill: "#353535"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M61 17C61 16.4477 60.5523 16 60 16C59.4477 16 59 16.4477 59 17C59 17.5523 59.4477 18 60 18C60.5523 18 61 17.5523 61 17Z",
    fill: "#353535"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M63 19C63 18.4477 62.5523 18 62 18C61.4477 18 61 18.4477 61 19C61 19.5523 61.4477 20 62 20C62.5523 20 63 19.5523 63 19Z",
    fill: "#353535"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M71 27C71 26.4477 70.5523 26 70 26C69.4477 26 69 26.4477 69 27C69 27.5523 69.4477 28 70 28C70.5523 28 71 27.5523 71 27Z",
    fill: "#353535"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M73 29C73 28.4477 72.5523 28 72 28C71.4477 28 71 28.4477 71 29C71 29.5523 71.4477 30 72 30C72.5523 30 73 29.5523 73 29Z",
    fill: "#353535"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M77 29C77 28.4477 76.5523 28 76 28C75.4477 28 75 28.4477 75 29C75 29.5523 75.4477 30 76 30C76.5523 30 77 29.5523 77 29Z",
    fill: "#353535"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M79 31C79 30.4477 78.5523 30 78 30C77.4477 30 77 30.4477 77 31C77 31.5523 77.4477 32 78 32C78.5523 32 79 31.5523 79 31Z",
    fill: "#353535"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M75 31C75 30.4477 74.5523 30 74 30C73.4477 30 73 30.4477 73 31C73 31.5523 73.4477 32 74 32C74.5523 32 75 31.5523 75 31Z",
    fill: "#353535"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M71 31C71 30.4477 70.5523 30 70 30C69.4477 30 69 30.4477 69 31C69 31.5523 69.4477 32 70 32C70.5523 32 71 31.5523 71 31Z",
    fill: "#353535"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M77 33C77 32.4477 76.5523 32 76 32C75.4477 32 75 32.4477 75 33C75 33.5523 75.4477 34 76 34C76.5523 34 77 33.5523 77 33Z",
    fill: "#353535"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M79 35C79 34.4477 78.5523 34 78 34C77.4477 34 77 34.4477 77 35C77 35.5523 77.4477 36 78 36C78.5523 36 79 35.5523 79 35Z",
    fill: "#353535"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M63 23C63 22.4477 62.5523 22 62 22C61.4477 22 61 22.4477 61 23C61 23.5523 61.4477 24 62 24C62.5523 24 63 23.5523 63 23Z",
    fill: "#353535"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M65 21C65 20.4477 64.5523 20 64 20C63.4477 20 63 20.4477 63 21C63 21.5523 63.4477 22 64 22C64.5523 22 65 21.5523 65 21Z",
    fill: "#353535"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M71 51C71 52.6569 69.6569 54 68 54C66.3431 54 65 52.6569 65 51C65 49.3431 66.3431 48 68 48C69.6569 48 71 49.3431 71 51Z",
    fill: "#28AF3E"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73 51C73 53.7614 70.7614 56 68 56C65.2386 56 63 53.7614 63 51C63 48.2386 65.2386 46 68 46C70.7614 46 73 48.2386 73 51ZM68 54C69.6569 54 71 52.6569 71 51C71 49.3431 69.6569 48 68 48C66.3431 48 65 49.3431 65 51C65 52.6569 66.3431 54 68 54Z",
    fill: "#191919"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M68 50C68 50.5523 67.5523 51 67 51C66.4477 51 66 50.5523 66 50C66 49.4477 66.4477 49 67 49C67.5523 49 68 49.4477 68 50Z",
    fill: "#B8FFAD"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M51 32.5C51 31.6716 51.6716 31 52.5 31C53.3284 31 54 31.6716 54 32.5V37.5C54 38.3284 53.3284 39 52.5 39C51.6716 39 51 38.3284 51 37.5V32.5Z",
    fill: "black"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M82 32.5C82 31.6716 82.6716 31 83.5 31C84.3284 31 85 31.6716 85 32.5V37.5C85 38.3284 84.3284 39 83.5 39C82.6716 39 82 38.3284 82 37.5V32.5Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoyan);
export default __webpack_public_path__ + "static/media/boyan.3ea5d1b5703675e3d2d0b262d36fc676.svg";
export { ForwardRef as ReactComponent };